import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { RecoveryActionEnum } from '../models/enums/recovery-action.enum';
import { IRecoveryDamage } from '../models/recovery-damage.model';
import {
  IAddLiableRequest,
  IPatchRecoveryRequest,
  IRecoveryActionRequest,
} from '../models/recovery-request.model';
import { IRecovery, IRecoverySummary } from '../models/recovery.model';

@Injectable({
  providedIn: 'root',
})
export class RecoveryApiService {
  private readonly http = inject(HttpClient);

  private readonly baseUrl = `${environment.services.claims}/api/recoveries`;

  public getRecoveriesByClaimId(
    claimId: number,
    filterHistoryByUserComments = false
  ): Observable<IRecovery[]> {
    return this.http.get<IRecovery[]>(`${this.baseUrl}/claim/${claimId}`, {
      params: { filterHistoryByUserComments },
    });
  }

  public getRecoveryById(
    recoveryId: number,
    filterHistoryByUserComments = false
  ): Observable<IRecovery> {
    return this.http.get<IRecovery>(`${this.baseUrl}/${recoveryId}`, {
      params: { filterHistoryByUserComments },
    });
  }

  public getRecoverySummary(claimId: number): Observable<IRecoverySummary> {
    return this.http.get<IRecoverySummary>(
      `${this.baseUrl}/claim/${claimId}/recovery-summary`
    );
  }

  public getRecoveryDamagesByClaim(
    claimId: number
  ): Observable<IRecoveryDamage[]> {
    return this.http.get<IRecoveryDamage[]>(
      `${this.baseUrl}/damages/${claimId}`
    );
  }

  public performAction(
    id: number,
    action: RecoveryActionEnum,
    body: IRecoveryActionRequest
  ): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/${id}/${action}`, body);
  }

  public patchRecovery(
    recoveryId: number,
    body: IPatchRecoveryRequest
  ): Observable<void> {
    return this.http.patch<void>(`${this.baseUrl}/${recoveryId}`, body);
  }

  public addLiableToRecovery(body: IAddLiableRequest): Observable<void> {
    return this.http.post<void>(this.baseUrl, body);
  }
}
